/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo, useState } from "react";
import { FlatList, StyleSheet, View } from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import { getDBManageOverview } from "@services/api";
import { useDispatch, useSelector } from "react-redux";
import { actions as homeWidgetActions } from "@reducers/homeWidgetReducer";
import color from "@constants/color";
import ListTile from "./components/ListTile";

const DbManagement = ({ navigation, route }) => {
  const [data, setData] = useState({});

  const { isStarCpHasActiveDbs = false } = useSelector(
    ({ configReducer }) => configReducer,
  );
  const isCmoCp = useSelector(({ auth }) => Boolean(auth?.user?.is_cmo_cp));
  const { "db-management": dbManagement = {} } = useSelector(
    (state) => state.homePageWidget?.widgets,
  );
  const dispatch = useDispatch();
  const { nav_params } = dbManagement;
  // Dark store CPs (tile `nav_params.dark_store`): Routing opens Dark Store
  // Routing directly; the old OFD page and the Routing menu (Assign Routes)
  // are not offered. Live DB Map and Manage Delivery Boy stay.
  const isDarkStore = Boolean(nav_params?.dark_store);
  const fetchData = async () => {
    try {
      // eslint-disable-next-line no-shadow
      const { data } = await getDBManageOverview();
      setData(data?.data);
      dispatch(homeWidgetActions.fetchHomePageWidget());
    } catch (error) {
      console.error("Error fetching DB management overview:", error);
    }
  };

  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, []),
  );

  const listData = useMemo(
    () => [
      {
        title: "Routing",
        type: "ROUTING",
        subtitle_1: "Pending Customers :",
        subtitle_1_value:
          nav_params?.routing_pending_cx || data?.routing_pending_cx,
        subtitle_2: isDarkStore ? undefined : "DB Unassigned Routes: ",
        subtitle_2_value: data?.routing_unassigned_cpdb_routes,
        nav_to: isDarkStore ? "DsRoutingHub" : "Routing",
        show_card: nav_params?.routing,
        nav_params_data: {
          ofd_pending_cx:
            nav_params?.routing_pending_cx || data?.routing_pending_cx,
          routing_unassigned_cpdb_routes: data?.routing_unassigned_cpdb_routes,
        },
      },
      {
        title: "Out For Delivery",
        type: "OUT_FOR_DELIVERY",
        subtitle_1: "Pending Customers :",
        subtitle_1_value: nav_params?.ofd_pending_cx,
        nav_to: "OutForDelivery",
        show_card: isDarkStore ? false : nav_params?.out_for_delivery,
        nav_params_data: {},
      },
      {
        title: "Recon",
        type: "RECON",
        subtitle_1: "Cash Short :",
        subtitle_1_value: `₹${data?.recon_cash_short || 0}`,
        subtitle_2: "Lost/Damage :",
        subtitle_2_value: data?.recon_item_short,
        nav_to: "Recon",
        show_card: nav_params?.db_recon,
        nav_params_data: {},
      },
      {
        title: "Live DB Map",
        type: "LIVE_DB_MAP",
        subtitle_1: "Active delivery boys :",
        subtitle_1_value: data?.active_dbs,
        nav_to: "LiveDbLocations",
        // Server enforces the same gate with a 403 on the endpoint.
        show_card: isCmoCp,
        nav_params_data: {},
      },
      {
        title: "Manage Delivery Boy",
        type: "MANAGE_DELIVERY_BOY",
        subtitle_1: "Total delivery boy :",
        subtitle_1_value: data?.active_dbs,
        nav_to: isStarCpHasActiveDbs ? "CreateDbOrList" : "CpDeliveryBoys",
        show_card: nav_params?.manage,
        nav_params_data: {},
      },
    ],
    [data, nav_params, isCmoCp, isDarkStore],
  );

  const renderItem = ({ item }) => <ListTile item={item} />;

  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        headertitle="Delivery Management"
        headerColor="#fff"
        hideShadow={true}
        navigation={navigation}
        route={route}
      />
      <FlatList
        data={listData}
        keyExtractor={(item) => item.type}
        renderItem={renderItem}
      />
    </View>
  );
};

export default DbManagement;

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: color.white },
});
